const items = [
  {
    id: 'topic-1',
    title: '直播带货翻车实录',
    desc: '盘点近期头部主播翻车名场面，从选品失察到夸大宣传，一桩桩事件背后是直播带货行业的野蛮生长与信任危机。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20warm%20golden%20lighting%2C%20products%20scattered%20on%20table%2C%20atmosphere%20of%20chaos%20and%20controversy%2C%20cinematic%20wide%20shot%2C%20dark%20moody%20background%20with%20soft%20spotlight%2C%20editorial%20photography%20style%2C%20warm%20crimson%20and%20amber%20tones&width=800&height=500&seq=carousel-topic-1&orientation=landscape',
  },
  {
    id: 'topic-2',
    title: '人设崩塌合集',
    desc: '那些曾经完美无瑕的网红人设，是如何一步步走向崩塌的？从公益人设到学霸标签，虚假光环背后是不堪一击的真相。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Shattered%20glass%20effect%20with%20golden%20light%20breaking%20through%2C%20abstract%20concept%20of%20broken%20facade%2C%20warm%20amber%20and%20deep%20red%20color%20scheme%2C%20dramatic%20lighting%20with%20dark%20background%2C%20editorial%20style%2C%20cinematic%20mood%2C%20elegant%20yet%20intense%20atmosphere&width=800&height=500&seq=carousel-topic-2&orientation=landscape',
  },
  {
    id: 'topic-3',
    title: '年度十大争议事件',
    desc: '回顾过去一年网红圈最具争议的十件大事，从艺人转型翻车到跨界商业纠纷，每件事都曾引爆全网讨论。',
    tag: '重磅回顾',
    img: 'https://readdy.ai/api/search-image?query=Top%2010%20ranking%20visualization%20in%20warm%20golden%20and%20crimson%20tones%2C%20abstract%20data%20visualization%20with%20glowing%20elements%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20news%20style%2C%20dark%20elegant%20background%20with%20spotlight%20effects%2C%20professional%20photography%20aesthetic&width=800&height=500&seq=carousel-topic-3&orientation=landscape',
  },
  {
    id: 'topic-4',
    title: '网红圈地下恋情',
    desc: '那些藏在镜头背后的隐秘恋情，从疑似同居到突然官宣，网红圈地下恋情大起底，每段故事都比剧本更精彩。',
    tag: '独家深扒',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20silhouette%20in%20warm%20dramatic%20lighting%2C%20two%20shadow%20figures%20against%20glowing%20amber%20background%2C%20mysterious%20and%20intimate%20atmosphere%2C%20cinematic%20photography%2C%20deep%20red%20and%20gold%20color%20palette%2C%20soft%20bokeh%20effects%2C%20editorial%20mood&width=800&height=500&seq=carousel-topic-4&orientation=landscape',
  },
  {
    id: 'topic-5',
    title: '平台算法与流量密码',
    desc: '深度解析各大平台的算法逻辑与流量分配机制，揭秘网红背后的流量密码——为什么有些内容能一夜爆红，有些却石沉大海？',
    tag: '行业揭秘',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20algorithm%20visualization%20with%20flowing%20data%20streams%20in%20warm%20golden%20and%20amber%20light%2C%20futuristic%20network%20connections%2C%20glowing%20nodes%2C%20elegant%20dark%20background%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20warm%20color%20palette%20with%20crimson%20accents&width=800&height=500&seq=carousel-topic-5&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">焦点专题</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">精选合集</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              className="group block bg-background-50 rounded-lg border border-secondary-200/60 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.classList.add('hidden');
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium text-background-50 bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {items.slice(3).map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-lg border border-secondary-200/60 hover:border-accent-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full sm:w-48 h-36 sm:h-auto flex-shrink-0 overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.classList.add('hidden');
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs font-medium text-background-50 bg-accent-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex-1 p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-accent-600 transition-colors mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}